// Composer drafts live in sessionStorage under ChatInput's `muse-draft-<id>`.
// Continue fresh copies an unsent draft into the successor chat's key so the
// writer's half-typed message survives, and clears the old one only once the
// new chat has rendered.

const draftKey = (sessionId: string) => `muse-draft-${sessionId}`;

/** Copy fromId's draft to toId unless toId already has one. Returns whether it copied. */
export function carryDraft(fromId: string, toId: string): boolean {
  try {
    const draft = sessionStorage.getItem(draftKey(fromId));
    if (!draft || draft.trim() === '') return false;
    if (sessionStorage.getItem(draftKey(toId))) return false;
    sessionStorage.setItem(draftKey(toId), draft);
    return true;
  } catch {
    return false;
  }
}

export function clearDraft(sessionId: string): void {
  try {
    sessionStorage.removeItem(draftKey(sessionId));
  } catch {
    // storage unavailable — nothing to clear
  }
}
